import Vue from 'vue'
import App from './App.vue'
import router from './router'

/* FA */

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faRocket,
  faChevronDown,
  faHeartBroken,
  faHeart,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faRocket, faChevronDown, faHeartBroken, faHeart, faUser);
Vue.component("icon", FontAwesomeIcon);

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
